import React, { useCallback, useState } from 'react'

import DropdownSheet from 'LuxKit/Dropdown/Sheet/DropdownSheet'
import DateRangePicker from 'tripPlanner/Tripkit/Common/DateRangePicker'

interface Props {
  triggerRef: React.RefObject<HTMLElement | null>
  isOpen: boolean
  startDate?: moment.Moment
  endDate?: moment.Moment
  onSelect: (startDate: moment.Moment, endDate: moment.Moment) => void
  onClear?: () => void
  onClose: () => void
}

function TripDatesDropdown({
  triggerRef,
  isOpen,
  startDate,
  endDate,
  onSelect,
  onClear,
  onClose,
}: Props) {
  const [selectedStartDate, setSelectedStartDate] = useState<
    moment.Moment | undefined
  >()

  const onSelectDates = useCallback(
    ({ startDate, endDate }: { startDate: moment.Moment, endDate?: moment.Moment }) => {
      if (endDate) {
        setSelectedStartDate(undefined)
        onSelect(startDate, endDate)
      } else {
        setSelectedStartDate(startDate)
      }
    },
    [onSelect],
  )

  const onRequestClose = useCallback(() => {
    setSelectedStartDate(undefined)
    onClose()
  }, [onClose])

  const onClickClear = useCallback(() => {
    setSelectedStartDate(undefined)
    onClear?.()
  }, [onClear])

  return (
    <DropdownSheet
      size="M"
      triggerRef={triggerRef}
      anchorRef={triggerRef}
      open={isOpen}
      onClose={onRequestClose}
      placement="bottom-start"
      crossAxisShift
      isSecondaryActionHidden={!onClear}
      secondaryActionProps={{
        kind: 'tertiary',
        children: 'Clear dates',
        onClick: onClickClear,
      }}
    >
      <DateRangePicker
        onDatesChange={onSelectDates}
        startDate={selectedStartDate ?? startDate}
        endDate={selectedStartDate ? undefined : endDate}
        allowSameDay
      />
    </DropdownSheet>
  )
}

export default TripDatesDropdown
